/*
 * @copyright (c) 2016, Philipp Thuerwaechter & Pattrick Hueper
 * @license BSD-3-Clause (see LICENSE.md in the root directory of this source tree)
 */

// import { DayOfMonth } from './DayOfMonth';
// import { DayOfYear } from './DayOfYear';
// import { Interval } from './Interval';
// import { LocalDateRange } from './LocalDateRange';
// import { OffsetDate } from './OffsetDate';
// import { Quarter } from './Quarter';
// import { Temporals } from './Temporals';
// import { YearQuarter } from './YearQuarter';
// import { YearWeek } from './YearWeek';

import './_init';

/**
 * @private
 *
 * plugin Function, call using js-jodas use()
 */
export default function (/* jsJoda */) {
    // assign new prop to jsJoda context is useless, because it lives only in the local context
    // jsJoda.DayOfMonth = DayOfMonth;
    // jsJoda.DayOfYear = DayOfYear;
    // jsJoda.Interval = Interval;
    // jsJoda.LocalDateRange = LocalDateRange;
    // jsJoda.OffsetDate = OffsetDate;
    // jsJoda.Quarter = Quarter;
    // jsJoda.Temporals = Temporals;
    // jsJoda.YearQuarter = YearQuarter;
    // jsJoda.YearWeek = YearWeek;
}
